import React from "react"
import { Progress } from "@heroui/react"
import { CardStat, Divider } from "@components"

import { 
  BellAlertIcon, 
  ChatBubbleLeftRightIcon, 
  EnvelopeIcon, 
  DocumentTextIcon 
} from "@heroicons/react/24/outline"

import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"

const CommunicationStats = ({
  eventId,
  noOfBookingConfirmationsPending = 0,
  noOfBookingConfirmationsSent = 0,
  noOfComments = 0,
  noOfInvitationsPending = 0,
  noOfInvitationsSent = 0,
  noOfNotifications = 0,
}) => {
  const navigate = useNavigate()
  const totalInvitations = noOfInvitationsSent + noOfInvitationsPending
  const totalBookingConfirmations = noOfBookingConfirmationsSent + noOfBookingConfirmationsPending
  const invitationsSentPercentage = Math.round(
    totalInvitations === 0 ? 0 : (noOfInvitationsSent / totalInvitations) * 100,
    0,
  )
  const bookingConfirmationsSentPercentage = Math.round(
    totalBookingConfirmations === 0 ? 0 : (noOfBookingConfirmationsSent / totalBookingConfirmations) * 100,
    0,
  )

  const getProgressColor = percentage => {
    if (percentage < 50) return "danger"
    if (percentage < 100) return "warning"
    return "success"
  }

  return (
    <React.Fragment>
      <CardStat
        title="Invitations Sent"
        icon={EnvelopeIcon}
        stat={`${invitationsSentPercentage}%`}
        meta={`${noOfInvitationsPending} Pending | ${noOfInvitationsSent} Sent`}
        handleClick={() => navigate(`/event/${eventId}/invitations`)}
      >
        <Progress
          color={getProgressColor(invitationsSentPercentage)}
          value={invitationsSentPercentage}
          aria-label="Invitations Sent"
        />
      </CardStat>

      <Divider className="my-3" />

      <CardStat
        title="Booking Confirmations"
        icon={DocumentTextIcon}
        stat={`${bookingConfirmationsSentPercentage}%`}
        meta={`${noOfBookingConfirmationsPending} Pending | ${noOfBookingConfirmationsSent} Sent`}
        handleClick={() => navigate(`/event/${eventId}/communications`)}
      >
        <Progress
          color={getProgressColor(bookingConfirmationsSentPercentage)}
          value={bookingConfirmationsSentPercentage}
          aria-label="Booking Confirmations"
        />
      </CardStat>

      <Divider className="my-3" />

      <CardStat
        title="Comments"
        icon={ChatBubbleLeftRightIcon}
        stat={`${noOfComments}`}
        meta={`Comments sent by parents and staff`}
        handleClick={() => navigate(`/event/${eventId}/reports/comments`)}
      />

      <Divider className="my-3" />

      <CardStat
        title="Notifications"
        icon={BellAlertIcon}
        stat={`${noOfNotifications}`}
        meta={`Notifications sent to parents or staff`}
        handleClick={() => navigate(`/event/${eventId}/communications`)}
      />
    </React.Fragment>
  )
}

CommunicationStats.propTypes = {
  eventId: PropTypes.string.isRequired,
  noOfBookingConfirmationsPending: PropTypes.number,
  noOfBookingConfirmationsSent: PropTypes.number,
  noOfComments: PropTypes.number,
  noOfInvitationsPending: PropTypes.number,
  noOfInvitationsSent: PropTypes.number,
  noOfNotifications: PropTypes.number,
}

export default CommunicationStats
